import { ShieldCheck } from 'lucide-react'
import { useStaat, zet } from '../lib/staat'
import { Knop, Venster } from './ui'

/* ===========================================================================
 *  "Bevestig even dat jij het bent"
 *
 *  Komt als de Worker 428 geeft (worker/sessie.ts, onder "Bevestigd"): op
 *  een code na een kwartier geen code bekeken, of bij "Bekijk als" (namens
 *  kijken, 0244). Bevestigen is een rondje langs het dashboard met
 *  ?opnieuw=1, en dan terug naar waar je was.
 *
 *  Een kwartier is gekozen omdat het precies de tijd is dat iemand een pc
 *  open laat staan "even koffie halen", en de codes hier zijn die van de
 *  kluis en het alarm.
 * =========================================================================== */

export default function Bevestigen() {
  const namens = useStaat((s) => s.bevestigenWaarom) === 'namens'
  const heen = location.pathname + location.search
  const sluit = () => zet({ bevestigen: false, bevestigenWaarom: null })
  return (
    <Venster titel={<><ShieldCheck size={18} /> Bevestig dat jij het bent</>} onSluit={sluit}
      voet={<>
        <Knop soort="stil" onClick={sluit}>Niet nu</Knop>
        <Knop soort="hoofd" onClick={() => location.assign(`/aanmelden?opnieuw=1&heen=${encodeURIComponent(heen)}`)}>Bevestigen</Knop>
      </>}>
      {namens ? (
        <>
          <p>Voordat je als een ander kijkt, vragen we het dashboard even of jij het bent.</p>
          <p className="veld-hulp">Daarna kom je hier terug. Je reden en de duur staan dan nog ingevuld; klik nog een keer op Starten.</p>
        </>
      ) : (
        <>
          <p>Je hebt een kwartier geen code bekeken. Voordat er een code op het scherm komt, vragen we het dashboard even of jij het nog bent.</p>
          <p className="veld-hulp">Daarna kom je hier terug, en kun je een kwartier lang codes bekijken.</p>
        </>
      )}
    </Venster>
  )
}
